module.exports = __webpack_public_path__ + "img/Smoking Cessation a Challenge in Malaysia.ca8fb532.jpg";